import React from 'react'
import styled from '@emotion/styled'

import vw from 'styles/utils';

function Advertisement(props) {
  return (
    <Root {...props} href="https://ieknet.iek.org.tw/IEKTopics/2022/" target="_blank">
    </Root>
  )
}

Advertisement.propTypes = {}

const Root = styled.a`
  width: 100%;
  /* height: 257px; */
  background: url(${require('assets/images/home/sidebar/advertisment.jpeg')});
  background-size: cover;
  /* background-position: center; */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${vw('height', 180, 400, 250)}
`;

export default Advertisement
